import {UserAuthority} from './user-type.enum';

export interface UserAuthorityResponse {
  authorities: UserAuthority[];
}

export interface UserRegion {
  id: string;
  name: string;
}

export interface UserProductGroup {
  id: string;
  name: string;
  parentOuId: string;
}
